export default __webpack_public_path__ + "static/media/satisfied.b8f8cc16.png";